export default __webpack_public_path__ + "static/media/011-no bike.6c786d64.png";